import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  private boundHandleClickOutside = this.handleClickOutside.bind(this)

  connect() {
    // Close dropdown when clicking outside
    document.addEventListener("click", this.boundHandleClickOutside)
  }

  disconnect() {
    document.removeEventListener("click", this.boundHandleClickOutside)
  }

  toggle(event: Event) {
    event.stopPropagation()
    const menu = this.element.querySelector('[data-dropdown-target="menu"]') as HTMLElement
    if (menu) {
      menu.classList.toggle("hidden")
    }
  }

  hide() {
    const menu = this.element.querySelector('[data-dropdown-target="menu"]') as HTMLElement
    if (menu) {
      menu.classList.add("hidden")
    }
  }

  private handleClickOutside(event: Event) {
    if (!this.element.contains(event.target as Node)) {
      this.hide()
    }
  }
}